import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBkvRSCIg3w68TKTJ0yIFCECsSVfG4uGZM',
  authDomain: 'meyebus-v0.firebaseapp.com',
  projectId: 'meyebus-v0',
  storageBucket: 'meyebus-v0.firebasestorage.app',
  messagingSenderId: '698341292426',
  appId: '1:698341292426:web:e3e760c86fd8ad23e73073',
  measurementId: 'G-3F2C3584R5',
};

const app = initializeApp(firebaseConfig);

// getMessaging(app) lève une exception synchrone dans tout environnement qui
// n'a pas les API navigateur requises (Node/jsdom en test, anciens Safari
// sans PWA installée...). isSupported() ne lève jamais — on l'utilise pour
// initialiser messaging paresseusement, une seule fois, uniquement quand
// c'est réellement supporté.
let messagingInstance;
let messagingChecked = false;

async function getMessagingInstance() {
  if (messagingChecked) {
    return messagingInstance;
  }
  messagingChecked = true;
  const supported = await isSupported().catch(() => false);
  messagingInstance = supported ? getMessaging(app) : null;
  return messagingInstance;
}

export { getMessagingInstance, getToken, onMessage };
